import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DirectusService } from './directus.service';
import { Storage } from '@ionic/storage-angular';
import { ToastController } from '@ionic/angular';

import { AppDataService } from 'src/app/services/app-data.service';
import { SystemLanguagesPipe } from 'src/app/pipes/system-languages.pipe';

@Injectable({
  providedIn: 'root'
})
export class CartService {
  cart = new BehaviorSubject<any>({
    items:
      []
  });
  systemLanguage = new BehaviorSubject([]);
  firstOrderTimeClient: any = null;
  constructor(
    private directusService: DirectusService,
    private toast: ToastController,
    private storage: Storage,
    private dataService: AppDataService,
    private systemLanguagesPipe: SystemLanguagesPipe
  ) {
    this.storage.get('cartItems').then(res => {
      this.cart.value.items = res ? JSON.parse(res) : [];
      this.cart.next(this.cart.value);
    });
    this.cart.subscribe(res => {
      this.saveData();
    });

    this.storage.get('first_time_order_client').then(res => {
      // console.log('first_time_order_client:', res);
      this.firstOrderTimeClient = res ? JSON.parse(res) : null;
    }).catch(e => {
      // console.log('first_time_order_client error:', e);
    });

    this.systemLanguage.next(this.dataService.systemLanguages[0]);
  }
  getItems() {

  }
  addItem(data) {
    let status = false;
    const items: any[] = this.cart.value.items;
    items.forEach(element => {
      if (element.id === data.id) {
        status = true;
        element.qty = (Number(element.qty) + Number(data.qty)).toString();
      }
    });
    if (!status) {
      items.push(data);
    }

    this.alert(this.translate('EShop', 'module_cart_msg_added_to_cart'));
    this.cart.next(this.cart.value);
  }

  updateItem(id, data) {
    let status = false;
    const items: any[] = this.cart.value.items;
    items.forEach(element => {
      if (element.id === id) {
        status = true;
        Object.assign(element, data);
      }
    });
    this.cart.next(this.cart.value);
  }

  removeItem(id) {
    const items = this.cart.value.items;
    items.splice(items.findIndex(el => {
      return el.id === id;
    }), 1);
    this.cart.next(this.cart.value);
  }
  placeOrder(body, collection?: string) {
    const ordersCollection = collection ?? 'orders';
    this.alert(this.translate('EShop', 'module_cart_msg_placing_order'));
    return this.directusService.api.createItem(ordersCollection, body).then(res => {
      // this.resetData();
      return res;
    });
  }
  saveData() {
    this.storage.set('cartItems', JSON.stringify(this.cart.value.items));
  }

  setFirstTimeOrderClient() {
    this.storage.get('userData').then(res => {
      this.storage.set('first_time_order_client', JSON.stringify(res));
    });
  }

  resetData() {
    this.cart.value.items = [];
    this.cart.next(this.cart.value);
  }
  async alert(message) {
    const toast = await this.toast.create({
      message,
      duration: 2000
    });
    toast.present();
  }

  public translate(moduleId, key) {
    const systemLanguages: any = this.dataService.systemLanguages[0];
    let addingToCartTxt = this.systemLanguagesPipe.transform(systemLanguages, moduleId, key);
    return addingToCartTxt;
  }
}
